import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import CoreLayout from './CoreLayout'
import GlobalError from './components/GlobalError'

const App = (): JSX.Element => {
  if (
    window.location.pathname === '/invalid-invitation/' ||
    window.location.pathname === '/'
  ) {
    return <GlobalError />
  }

  return (
    <Router>
      <Routes>
        <Route path="/:prospectId/*" element={<CoreLayout />} />
      </Routes>
    </Router>
  )
}

export default App
